import React, { useState, useEffect } from "react";
import { ConfirmDialog } from "primereact/confirmdialog";
import $ from "jquery";
import { useDispatch, useSelector } from "react-redux";
import InfoIcon from "../../../../../Images/informationIcon.png";
import TooltipText from "../TooltipText";
import { DisplayMsg } from "../../../../../services/toastService";
import { EMAIL_REGEX } from "../../../../../constants/regex";
import { FetchData, PostData, UpdateData } from "../../../../../utils/array";
import { setCurrentPracticeData } from "../../../../../store/reducers/SharedLayoutDataSlice";
import { loadConfigurationData } from "../../../../../handlers/ClientDetail/Configurations Setup/configurationsHandler";
import PayrixSetting from "./PayrixSetting";

const Setting = (props) => {
  const sharedData = useSelector((state) => state.SharedLayoutData);
  const dispatch = useDispatch();
  const [toggleObj, setToggleObj] = useState(null);
  const [Error, setError] = useState({
    secretKey: "",
    apiKey: "",
    faxNumb: "",
    CallErr: "",
    FileErr: "",
    email: "",
    password: "",
    template: "",
    portalUrl: "",
    companyName: "",
    practiceName: "",
    medicationUser: "",
    labUser: "",
    registerUser: "",
  });
  const [FaxData, setFaxData] = useState({
    faxNumb: "",
    path: "",
    FaxVal: "N",
    FaxBtn: true,
    faxId: "",
  });
  const [KiosData, setKiosData] = useState({
    email: "",
    password: "",
    template: "",
    reason: "",
    ReasonDisable: true,
    KiosVal: "N",
    kiosBtn: false,
    createBtn: true,
  });
  const [PortalData, setPortalData] = useState({
    portalId: "",
    portalUrl: "",
    companyName: "",
    practiceName: "",
    medicationUser: "",
    labUser: "",
    registerUser: "",
    portalBtn: false,
    location: null,
    provider: null,
    portalConfig: true,
    portalSetup: "N",
    update: false,
  });

  const [VisitData, setVisitData] = useState({
    secretKey: "",
    apiKey: "",
    visitVal: "",
    reason: "",
    visitBtn: true,
  });
  const [confirm, setConfirm] = useState(false);
  const [LocationData, setLocationData] = useState([]);
  const [ProviderData, setProviderData] = useState([]);
  const [detail, setDetail] = useState("");
  const [popup, setPopup] = useState(false);
  const [Boxes, setBoxes] = useState({ message: "", check: false });
  const [kiosToggle, setKiosToggle] = useState({
    title: "Kiosk Setup Activation",
    visible: "N",
    flag: "Kiosk_Setup_Deactivation",
    HELP_TEXT: "This option turns off Kiosk Setup.",
    adv_option_seq_num: null,
    disable: true,
  });
  const [PortalToggle, setPortalToggle] = useState({
    title: "New Patient Registration",
    flag: "NEW_REGISTATION_FLOW",
    visible: "N",
    HELP_TEXT: "This option turns on New Patient Registration workflow.",
    type: "newPatientRegistration",
    disable: false,
  });
  const [VisitToggle, setVisitToggle] = useState({
    title: "Televisit Setup",
    flag: "IS_TELE_CLINIC",
    visible: "N",
    HELP_TEXT:
      "This option turns off Tele Visit bucket in dashboard and enables Televisit flow.",
    type: "teleVisit",
    disable: false,
  });
  const [AmbirToggle, setAmbirToggle] = useState({
    title: "Ambir Scanning",
    flag: "CSSN_LICENCE_KEY",
    visible: "N",
    HELP_TEXT: "This option turns off Ambir Scanning.",
    type: "ambirScanning",
    disable: false,
  });
  let check = true;
  useEffect(() => {
    LoadKioskAdminData();

    LoadSettingsData();
    TriggerAmbirSettingToggle();
  }, [props]);

  const LoadKioskAdminData = async () => {
    const queryParams = new URLSearchParams({
      facilityId:
        sharedData.currentFacilityId === 0 ? "" : sharedData.currentFacilityId,
    }).toString();

    try {
      const response = await FetchData(
        `Kiosk/${sharedData.currentEntityId}`,
        "auth",
        queryParams
      );

      if (response && response.succeeded) {
        console.log("The current response of web_auth kiosk is ", response);

        if (response.data != null) {
          const kioskData = response.data;
          setKiosData((kiosInfo) => ({
            ...kiosInfo,
            email: kioskData.email,
            password: kioskData.password,
            template: kioskData.templateSeqNum,
          }));

          setKiosToggle((toggleInfo) => ({
            ...toggleInfo,
            visible: "Y",
            disable: false,
          }));
        } else {
          setKiosData((kiosInfo) => ({
            ...kiosInfo,
            KiosVal: "N",
          }));

          setKiosToggle((toggleInfo) => ({
            ...toggleInfo,
            visible: "N",
            disable: true,
          }));
        }

        document.getElementById("loader").style.display = "none";
      } else {
        DisplayMsg("2", response.Message);
        console.log("The current response is false is", response);
      }
    } catch (error) {
      document.getElementById("loader").style.display = "none";
      DisplayMsg("2", "⚠️ Auth Api is unable to connect to server.");
    }
  };

  useEffect(() => {
    TriggerAmbirSettingToggle();
  }, [sharedData.currentPracticeData]);


  const TriggerAmbirSettingToggle = () => {
    if (
      sharedData.currentPracticeData != null &&
      sharedData.currentPracticeData.cssnLicenseKey != null
    ) {
      setAmbirToggle((toggleInfo) => ({
        ...toggleInfo,
        visible: "Y",
        HELP_TEXT: "This option turns off Ambir Scanning",
      }));
    } else {
      setAmbirToggle((toggleInfo) => ({
        ...toggleInfo,
        visible: "N",
        HELP_TEXT: "This option turns on Ambir Scanning",
      }));
    }

    let message = "on";
    if (
      sharedData?.currentPracticeData != null &&
      sharedData?.currentPracticeData?.isTeleClinic === "Y"
    ) {
      message = "off";
    }
    setVisitToggle((toggleInfo) => ({
      ...toggleInfo,
      visible: sharedData?.currentPracticeData?.isTeleClinic,
      HELP_TEXT:
        `This option turns ${message
        } Tele Visit bucket in dashboard and enables Televisit flow.`,
    }));
  };

  const DisableToggle = () => {
    if (
      sessionStorage.getItem("type") === "CS" ||
      sessionStorage.getItem("type") === "CSM"
    ) {
      setPortalToggle((toggleInfo) => ({
        ...toggleInfo,
        disable: true,
      }));

      setVisitToggle((toggleInfo) => ({
        ...toggleInfo,
        disable: true,
      }));

      setKiosToggle((toggleInfo) => ({
        ...toggleInfo,
        disable: true,
      }));

      setAmbirToggle((toggleInfo) => ({
        ...toggleInfo,
        disable: true,
      }));
    }
  };

  const LoadSettingsData = async () => {
    document.getElementById("loader").style.display = "block";
    const queryParams = new URLSearchParams({
      facilityId:
        sharedData.currentFacilityId === 0 ? "" : sharedData.currentFacilityId,
    }).toString();

    try {
      const response = await FetchData(
        `Practice/${sharedData.currentEntityId}/setting`,
        "PEHR",
        queryParams,
        sharedData.clientApiKey
      );
      if (response && response.succeeded) {
        document.getElementById("loader").style.display = "none";
        const settingData = response.data;
        if (settingData.faxData != null) {
          if (settingData.faxData.length > 0) {
            const Fax = settingData.faxData[0];
            setFaxData((faxInfo) => ({
              ...faxInfo,
              FaxVal: "Y",
              faxNumb: Fax.faxNumber,
              path: Fax.faxReceivedPath,
              faxId: Fax.id,
            }));
          } else {
            setFaxData((faxInfo) => ({
              ...faxInfo,
              FaxVal: "N",
            }));
          }
        } else {
          setFaxData((faxInfo) => ({
            ...faxInfo,
            FaxVal: "N",
          }));
        }
        LoadLocationProvider(settingData);

        if (settingData.portalData != null) {
          if (settingData.portalData.length > 0) {
            const portalData = settingData.portalData[0];
            if (
              portalData.openTokApiKey != null &&
              portalData.openTokSecretKey != null
            ) {
              setVisitData((visitInfo) => ({
                ...visitInfo,
                visitVal: "Y",
                secretKey: portalData.openTokSecretKey,
                apiKey: portalData.openTokApiKey,
                reason: settingData.teleVisitReason,
              }));

              setVisitToggle((visitInfo) => ({
                ...visitInfo,
                visible: "Y",
                disable: false,
              }));
            } else {
              setVisitData((visitInfo) => ({
                ...visitInfo,
                visitVal: "N",
              }));

              setVisitToggle((visitInfo) => ({
                ...visitInfo,
                visible: "N",
                disable: true,
              }));
            }
            setPortalData((portalInfo) => ({
              ...portalInfo,
              portalUrl: portalData.portalUrl,
              companyName: portalData.companyName,
              practiceName: portalData.practiceName,
              medicationUser: portalData.defaultMedicationUser,
              labUser: portalData.defaultLabUser,
              registerUser: portalData.defaultPatRegUser,
              portalSetup: "Y",
              update: true,
              portalId: portalData.id,
            }));

            if (portalData.portalUrl != null) {
              setPortalData((portalInfo) => ({
                ...portalInfo,
                portalBtn: true,
              }));
            }
            let NewPatientmessage = "off";
            if (
              portalData.newRegistationFlow === "N" ||
              portalData.newRegistationFlow == null
            ) {
              NewPatientmessage = "on";
            }

            setPortalToggle((toggleInfo) => ({
              ...toggleInfo,
              visible: portalData.newRegistationFlow,
              HELP_TEXT:
                `This option turns ${NewPatientmessage
                } New Patient Registration workflow`,
            }));

            if (portalData.newRegistationFlow === "Y") {
              setPortalData((portalInfo) => ({
                ...portalInfo,
                portalConfig: true,
              }));
            }

            if (
              portalData &&
              portalData.newPatientLocationId &&
              portalData.newPatientProviderId
            ) {
              setPortalData((portalInfo) => ({
                ...portalInfo,
                location: portalData.newPatientLocationId,
                provider: portalData.newPatientProviderId,
              }));
            }
          }
        } else {
          setPortalData((portalInfo) => ({
            ...portalInfo,
            portalSetup: "N",
            update: false,
          }));
        }

        if (settingData.teleVisitReason != null) {
          setVisitData((visitInfo) => ({
            ...visitInfo,
            reason: settingData.teleVisitReason,
            visitBtn: settingData.teleVisitReason == null,
          }));
        } else {
          setVisitData((visitInfo) => ({
            ...visitInfo,
            visitBtn: true,
          }));
        }

        if (settingData.kioskReason != null) {
          setKiosData((kiosInfo) => ({
            ...kiosInfo,
            kiosBtn: false,
            reason: settingData.kioskReason,
          }));
        } else {
          setKiosData((kiosInfo) => ({
            ...kiosInfo,
            kiosBtn: true,
          }));
        }

        if (
          sessionStorage.viewOnly.toUpperCase() === "N" &&
          sessionStorage.type.toUpperCase() === "IT" &&
          sessionStorage.fullAccess.toUpperCase() === "Y"
        ) {
          setKiosToggle((toggleInfo) => ({
            ...toggleInfo,
            disable: false,
          }));
          setFaxData((faxInfo) => ({
            ...faxInfo,
            FaxBtn: true,
          }));

          setKiosData((faxInfo) => ({
            ...faxInfo,
            kiosBtn: true,
            ReasonDisable: false,
          }));

          if (settingData.kioskData == null) {
            setKiosToggle((toggleInfo) => ({
              ...toggleInfo,
              visible: "N",
              disable: true,
            }));
          }
          if (settingData.kioskReason != null) {
            setKiosData((faxInfo) => ({
              ...faxInfo,
              createBtn: false,
              reason: settingData.kioskReason,
            }));
          }
        } else if (
          sessionStorage.viewOnly.toUpperCase() === "N" &&
          sessionStorage.type.toUpperCase() === "M" &&
          sessionStorage.fullAccess.toUpperCase() === "Y"
        ) {
          setKiosToggle((toggleInfo) => ({
            ...toggleInfo,
            disable: false,
          }));

          setKiosData((faxInfo) => ({
            ...faxInfo,
            kiosBtn: true,
            ReasonDisable: false,
          }));
        } else {
          setKiosToggle((toggleInfo) => ({
            ...toggleInfo,
            disable: true,
          }));

          setKiosData((faxInfo) => ({
            ...faxInfo,
            ReasonDisable: true,
            kiosBtn: false,
          }));
        }

        if (settingData.kioskReason != null) {
          setKiosData((faxInfo) => ({
            ...faxInfo,
            reason: settingData.kioskReason,
            kiosBtn: false,
          }));
        }

        DisableToggle();

        document.getElementById("loader").style.display = "none";
      } else if (response && response.Errors && Array.isArray(response.Errors)) {
        const infraError = response.Errors.find(err => err.PropertyName === "Infrastructure" && err.ErrorMessage.includes("Object reference not set to an instance of an object."));
        if (infraError) {
          DisplayMsg("2", "Its a Enterprise Client and doesn't have directly DB Access");
        } else {
          DisplayMsg("2", response.Message);
        }
      }
      else {
        DisplayMsg("2", response.Message);
        console.log("The current response is false is", response);
      }
    } catch (error) {
      document.getElementById("loader").style.display = "none";
      DisplayMsg("2", "⚠️ Patient Api is unable to connect to server.");
    }
  };

  const LoadLocationProvider = (response) => {
    if (LocationData.length < 1) {
      const locationInfo = {
        value: "",
        label: "Please Select Location",
      };

      setLocationData((prevLocation) => [...prevLocation, locationInfo]);
    }

    if (response.locationInfo != null) {
      response.locationInfo.forEach((item, key) => {
        const locationInfo = {
          value: item.locationId,
          label: item.locationName,
        };
        setLocationData((prevLocation) => [...prevLocation, locationInfo]);
      });
    }

    if (ProviderData.length < 1) {
      const providerInfo = {
        value: "",
        label: "Please Select Provider",
      };

      setProviderData((prevProvider) => [...prevProvider, providerInfo]);
    }

    if (response.providerInfo != null) {
      response.providerInfo.forEach((item, key) => {
        const providerInfo = {
          value: item.id,
          label: item.fullName,
        };
        setProviderData((prevProvider) => [...prevProvider, providerInfo]);
      });
    }
  };

  const accept = () => {
    setBoxes((boxesValue) => ({
      ...boxesValue,
      check: true,
    }));
    Confirm(true);
  };

  const reject = () => {
    $(`#setting_${toggleObj.flag}`)[0].checked = false;
  };

  const Confirm = async (answer) => {
    const { flag, e, visible, type } = toggleObj;

    if (answer === true) {
      if (flag === "Kiosk_Setup_Deactivation") {
        document.getElementById("loader").style.display = "block";
        const toggleInfo = {
          AuthEntityId: sharedData.currentClientId,
          EntityId: sharedData.currentEntityId,
          FacilityId:
            sharedData.currentFacilityId === 0
              ? ""
              : sharedData.currentFacilityId,
          Type: "kioskInActive",
        };

        const Kiosk_Info = Object.fromEntries(
          Object.entries(toggleInfo).map(([key, value]) => [key, String(value)])
        );

        const response = await UpdateData(
          "Practice/updateKioskSetup",
          Kiosk_Info,
          "auth"
        );
        if (response && response.succeeded) {
          setKiosData((kiosInfo) => ({
            ...kiosInfo,
            email: "",
            password: "",
            template: "",
          }));

          setKiosToggle((toggleInfo) => ({
            ...toggleInfo,
            visible: "N",
            disable: true,
          }));
          DisplayMsg("1", response.message);
        } else {
          DisplayMsg("2", response.message);
        }
      } else if (type === "newPatientRegistration") {
        const queryParams = new URLSearchParams({
          facilityId:
            sharedData.currentFacilityId === 0
              ? ""
              : sharedData.currentFacilityId,
          flag,
          isVisible: visible,
        }).toString();
        const response = await UpdateData(
          `Practice/${sharedData.currentEntityId}/phrPortalOption`,
          null,
          "PEHR",
          queryParams,
          sharedData.clientApiKey,
          "PATCH"
        );

        if (response && response.succeeded) {
          setPortalToggle((toggleInfo) => ({
            ...toggleInfo,
            visible: PortalToggle.visible === "Y" ? "N" : "Y",
          }));

          setProviderData([]);
          setLocationData([]);

          LoadSettingsData();
          LoadConfigurationData();

          if (PortalToggle.visible === "Y") {
            response.message = "New Registation Flow De-Activated successfully";
          } else {
            response.message = "New Registation Flow Activated successfully";
          }
          DisplayMsg("1", response.message);
        } else {
          DisplayMsg("2", response.message);
        }
      } else if (type === "teleVisit") {
        document.getElementById("loader").style.display = "block";
        const toggleInfo = {
          AuthEntityId: sharedData.currentClientId,
          EntityId: sharedData.currentEntityId,
          FacilityId:
            sharedData.currentFacilityId === 0
              ? ""
              : sharedData.currentFacilityId,
          Flag: flag,
          Visible: visible,
          ClientApiKey: sharedData.clientApiKey,
        };

        const stringifiedToggleInfo = Object.fromEntries(
          Object.entries(toggleInfo).map(([key, value]) => [key, String(value)])
        );

        const response = await UpdateData(
          "Practice/updateTelevisit",
          stringifiedToggleInfo,
          "auth"
        );

        if (response && response.succeeded) {
          if (flag === "CSSN_LICENCE_KEY" || flag === "IS_TELE_CLINIC") {
            if (flag === "IS_TELE_CLINIC") {
              setVisitData((visitInfo) => ({
                ...visitInfo,
                apiKey: "",
                secretKey: "",
              }));
            }
            LoadSettingsData();
          }
          DisplayMsg("1", response.message);
        } else {
          DisplayMsg("2", response.message);
        }
      } else if (type === "ambirScanning") {
        document.getElementById("loader").style.display = "block";

        const queryParams = new URLSearchParams({
          entityId: sharedData.currentEntityId,
          visible,
          facilityId:
            sharedData.currentFacilityId === 0
              ? ""
              : sharedData.currentFacilityId,
        }).toString();
        const response = await UpdateData(
          "Practice/updateAmbirScanning",
          null,
          "auth",
          queryParams,
          "",
          "PATCH"
        );

        if (response && response.succeeded) {
          if (flag === "CSSN_LICENCE_KEY" || flag === "IS_TELE_CLINIC") {
            LoadConfigurationData();
          }
          DisplayMsg("1", response.message);
        } else {
          DisplayMsg("2", response.message);
        }
      }
    } else if (e.target.checked === true) {
      e.target.checked = false;
    } else {
      e.target.checked = true;
    }
  };

  const LoadConfigurationData = async () => {
    const configData = await loadConfigurationData(
      sharedData.currentClientId,
      dispatch
    );
    if (configData) {
      if (configData.entityData != null) {
        dispatch(setCurrentPracticeData(configData.entityData));
      }
    }
  };

  const AlterSettingData = (event, type) => {
    const { name } = event.target;
    const curVal = event.target.value;
    if (type === "fax") {
      setFaxData((faxInfo) => ({
        ...faxInfo,
        [name]: curVal,
      }));
    } else if (type === "kiosk") {
      setKiosData((kiosInfo) => ({
        ...kiosInfo,
        [name]: curVal,
      }));
    } else if (type === "portal") {
      setPortalData((portalInfo) => ({
        ...portalInfo,
        [name]: curVal,
      }));
    } else if (type === "teleVisit") {
      setVisitData((visitInfo) => ({
        ...visitInfo,
        [name]: curVal,
      }));
    }
    ShowErrorMsg(name, curVal);
  };

  let ShowErrorMsg = (field, value) => {
    if (value.length > 0) {
      setError((errorInfo) => ({
        ...errorInfo,
        [field]: "",
      }));
    } else {
      setError((errorInfo) => ({
        ...errorInfo,
        [field]: "Required",
      }));
    }
  };

  const SaveFax = async () => {
    let isValid = true;
    if (FaxData.faxNumb.length < 1) {
      setError((errorInfo) => ({
        ...errorInfo,
        faxNumb: "Required",
      }));
      isValid = false;
    } else if (isNaN(FaxData.faxNumb) === true) {
      setError((errorInfo) => ({
        ...errorInfo,
        faxNumb: "Invalid Number",
      }));
      isValid = false;
    }

    const path = FaxData.path.split("\\");
    let newPath = `${path[0]}\\${path[1]}\\${FaxData.faxNumb}`;
    if (newPath.includes("undefined")) {
      newPath = `D:\\Inbound Faxes\\${FaxData.faxNumb}`;
      setFaxData((faxInfo) => ({
        ...faxInfo,
        path: `D:\\Inbound Faxes\\${FaxData.faxNumb}`,
      }));
    }
    if (isValid) {
      document.getElementById("loader").style.display = "block";
      const formData = new FormData();
      formData.append("EntitySeq_num", sessionStorage.ENTITY_SEQ_NUM);
      formData.append("FaxNumber", FaxData.faxNumb);
      formData.append("TNSName", sessionStorage.tnsName);
      formData.append("IsSaved", FaxData.FaxVal);

      const faxData = {
        entityId: sharedData.currentEntityId,
        facilityId:
          sharedData.currentFacilityId === 0
            ? ""
            : sharedData.currentFacilityId,
        faxNumber: FaxData.faxNumb,
        faxReceivePath: newPath,
        ClientApiKey: sharedData.clientApiKey,
      };

      const fax_Data = Object.fromEntries(
        Object.entries(faxData).map(([key, value]) => [key, String(value)])
      );

      const currentAction = FaxData.faxId !== "" ? UpdateData : PostData;

      const response = await currentAction(
        PortalData.update
          ? `Practice/${FaxData.faxId?.toString()}/faxSetup`
          : "Practice/faxSetup",
        fax_Data,
        "PEHR",
        null,
        sharedData.clientApiKey
      );
      if (response && response.succeeded) {
        setFaxData((faxInfo) => ({
          ...faxInfo,
          FaxVal: "Y",
        }));
        DisplayMsg("1", response.message);
      } else {
        DisplayMsg("2", response.message);
      }
    }
  };

  const ValidateBoxLength = (event) => {
    const { name } = event.target;
    const curVal = event.target.value;
    ShowErrorMsg(name, curVal);
  };

  const ConfigrationSetup = (item) => {
    const isChecked = item.visible === "Y";

    return (
      <div className="col-md-12 col-sm-12">
        <div className="switch-container">
          <span className="switch-field-placeholder">
            {item.title}
            <span
              className="info-tooltip"
              onClick={() => BindHelpText(item.HELP_TEXT)}
            >
              <img className="lbl-tooltip" src={InfoIcon} alt="" />
            </span>
            <label className="switch">
              <input
                type="checkbox"
                id={`setting_${item.flag}`}
                onChange={(e) =>
                  ToogleFlag(
                    item.title,
                    item.flag,
                    item.visible,
                    item.type,
                    item.disable,
                    e
                  )
                }
                checked={isChecked}
                disabled={item.disable}
              />
              <span className="slider round" />
            </label>
          </span>
        </div>
      </div>
    );
  };

  const BindHelpText = (text) => {
    setDetail(text);
    setPopup(true);
  };

  const ToogleFlag = (title, flag, visible, type, disable, e) => {
    let textMessage = "";
    if (visible === "N" || visible === "n" || visible === null) {
      textMessage = "Are you sure you want to turn on this flag?";
      visible = "Y";
    } else {
      visible = "N";
      textMessage = "Are you sure you want to turn off this flag?";
    }

    setToggleObj({
      visible,
      flag,
      e,
      type,
    });

    const { checked } = e.target;

    if (checked) {
      visible = "Y";
    } else {
      visible = "N";
    }

    setBoxes((boxesValue) => ({
      ...boxesValue,
      message: textMessage,
    }));
    setConfirm(true);
  };

  const CreateReason = async (reasonType) => {
    const queryParams = new URLSearchParams({
      type: reasonType,
    }).toString();

    document.getElementById("loader").style.display = "block";

    const response = await FetchData(
      `Practice/${sharedData.currentEntityId}/kioskReason`,
      "PEHR",
      queryParams,
      sharedData.clientApiKey
    );

    if (response && response.succeeded) {
      if (reasonType === "teleVisit") {
        setVisitData((kiosInfo) => ({
          ...kiosInfo,
          reason: response.data.id,
          visitBtn: false,
        }));
      } else {
        setKiosData((kiosInfo) => ({
          ...kiosInfo,
          reason: response.data.id,
          kiosBtn: false,
        }));
      }
      DisplayMsg("1", response.message);
    } else {
      DisplayMsg("2", response.message);
    }
  };

  const VerifyFields = () => {
    for (const plan in PortalData) {
      if (
        plan !== "portalBtn" &&
        plan !== "portalConfig" &&
        plan !== "location" &&
        plan !== "provider" &&
        plan !== "portalId"
      ) {
        if (PortalData[plan] === "" || PortalData[plan] == null) {
          setError((errorInfo) => ({
            ...errorInfo,
            [plan]: "Required",
          }));
          check = false;
        } else {
          setError((errorInfo) => ({
            ...errorInfo,
            [plan]: "",
          }));
        }
      }
    }
  };

  const PortalSetup = async () => {
    VerifyFields();
    if (check) {
      document.getElementById("loader").style.display = "block";

      const portalInfo = {
        entityId: sharedData.currentEntityId,
        facilityId:
          sharedData.currentFacilityId === 0
            ? ""
            : sharedData.currentFacilityId,
        patientPortalUrl: PortalData.portalUrl,
        registrationUser: PortalData.registerUser,
        companyName: PortalData.companyName,
        practiceName: PortalData.companyName,
        medicationUser: PortalData.medicationUser,
        labUser: PortalData.labUser,
        location: PortalData?.location !== null ? PortalData?.location.toString() : "",
        provider: PortalData?.provider !== null ? PortalData?.provider.toString() : "",
        isSaved: PortalData.portalSetup,
      };

      const portal_Info = Object.fromEntries(
        Object.entries(portalInfo).map(([key, value]) => [key, String(value)])
      );

      const response =
        PortalData.portalId !== ""
          ? await UpdateData(
            `Practice/${PortalData.portalId}/updatePortal`,
            portal_Info,
            "PEHR",
            null,
            sharedData.clientApiKey
          )
          : await PostData(
            "Practice/createPortal",
            portal_Info,
            "PEHR",
            sharedData.clientApiKey
          );
      if (response && response.succeeded) {
        DisplayMsg("1", response.message);
      } else if (response && response.Errors && Array.isArray(response.Errors)) {
        const infraError = response.Errors.find(err => err.PropertyName === "Infrastructure" && err.ErrorMessage.includes("Object reference not set to an instance of an object."));
        if (infraError) {
          DisplayMsg("2", "DB connection is not set for this client");
        } else {
          DisplayMsg("2", response.Message);
        }
      }
      else {
        DisplayMsg("2", response.message);
      }

      // const response = await currentAction(
      //   PortalData.update
      //     ? `Practice/${PortalData.portalId}/updatePortal`
      //     : "Practice/createPortal",
      //   portal_Info,
      //   "PEHR",
      //   PortalData.portalId === "" ? sharedData.clientApiKey : null,
      //   PortalData.portalId !== "" ? sharedData.clientApiKey : null
      // );
      // if (response && response.succeeded) {
      //   DisplayMsg("1", response.message);
      // } else {
      //   DisplayMsg("2", response.message);
      // }
    }
  };

  const KioskSetup = async () => {
    let isValid = true;
    if (KiosData.email.length < 1) {
      ShowErrorMsg("email", KiosData.email);
      isValid = false;
      return;
    }
    if (!EMAIL_REGEX.test(KiosData.email)) {
      setError((errorInfo) => ({
        ...errorInfo,
        email: "❌ Email is not valid!",
      }));
      isValid = false;
      return;
    }

    if (KiosData.password.length < 1) {
      ShowErrorMsg("password", KiosData.password);
      isValid = false;
      return;
    }

    if (KiosData.template.length < 1) {
      ShowErrorMsg("template", KiosData.template);
      isValid = false;
      return;
    }

    if (isNaN(KiosData.template) === true) {
      setError((errorInfo) => ({
        ...errorInfo,
        template: "Invalid Number",
      }));
      isValid = false;
    }

    if (isValid) {
      document.getElementById("loader").style.display = "block";
      const KioskSetupData = {
        AuthEntityId: sharedData.currentClientId,
        EntityId: sharedData.currentEntityId,
        FacilityId:
          sharedData.currentFacilityId === 0
            ? ""
            : sharedData.currentFacilityId,
        Email: KiosData.email,
        Password: KiosData.password,
        templateId: KiosData.template,
        IsSaved: kiosToggle.visible,
        Type: "KioskSetup",
        ClientApiKey: sharedData.clientApiKey,
      };

      const stringifiedKioskSetupData = Object.fromEntries(
        Object.entries(KioskSetupData).map(([key, value]) => [
          key,
          String(value),
        ])
      );

      const response = await UpdateData(
        `Practice/updateKioskSetup`,
        stringifiedKioskSetupData,
        "auth"
      );

      if (response && response.succeeded) {
        setKiosToggle((toggleInfo) => ({
          ...toggleInfo,
          visible: "Y",
          disable: false,
        }));

        DisplayMsg("1", response.message);
      } else {
        DisplayMsg("2", response.message);
      }
    }
  };

  const TeleVisitSetup = async () => {
    let isvalid = true;

    if (VisitData.secretKey.length < 1) {
      ShowErrorMsg("secretKey", VisitData.secretKey);
      isvalid = false;
    }
    if (VisitData.apiKey.length < 1) {
      ShowErrorMsg("apiKey", VisitData.apiKey);
      isvalid = false;
    }

    if (isvalid) {
      document.getElementById("loader").style.display = "block";
      const TeleVisitData = {
        AuthEntityId: sharedData.currentClientId,
        EntityId: sharedData.currentEntityId,
        Flag: "IS_TELE_CLINIC",
        Visible: 'Y',
        openTokSeceretKey: VisitData.secretKey,
        openTokApiKey: VisitData.apiKey,
        FacilityId:
          sharedData.currentFacilityId === 0
            ? ""
            : sharedData.currentFacilityId,
        ClientApiKey: sharedData.clientApiKey,
      };

      const stringifiedTeleVisitData = Object.fromEntries(
        Object.entries(TeleVisitData).map(([key, value]) => [
          key,
          String(value),
        ])
      );

      const response = await UpdateData(
        `Practice/updateTelevisit/`,
        stringifiedTeleVisitData,
        "auth"
      );

      if (response && response.succeeded) {
        setVisitData((visitInfo) => ({
          ...visitInfo,
          visitVal: "Y",
        }));

        setVisitToggle((toggleInfo) => ({
          ...toggleInfo,
          visible: "Y",
          disable: false,
        }));

        DisplayMsg("1", response.message);
      } else {
        DisplayMsg("1", response.message);
      }
    }
  };

  const CloseTooltip = () => {
    setDetail("");
    setPopup(false);
  };

  return (
    <>
      {popup && <TooltipText tooltip={detail} parentCallback={CloseTooltip} />}
      <div className="row">
        <div className="col-md-6 col-sm-12">
          <div className="row table-panel-header mt-4 bg-white">
            <div className="col-md-12">
              <h6>Fax Setup</h6>
            </div>
          </div>
          <div className="col-md-12 col-sm-12">
            <div className="field-container">
              <label className="field-placeholder font-medium">
                Fax Number <span className="redboxRequired" />{" "}
              </label>
              <input
                type="text"
                className="field-input"
                name="faxNumb"
                value={FaxData.faxNumb}
                onChange={(e) => AlterSettingData(e, "fax")}
                onFocus={(e) => ValidateBoxLength(e, "fax")}
                required
                maxLength={10}
              />
            </div>
            <label className="requiredtext">{Error.faxNumb}</label>
          </div>
          <div className="col-md-12 col-sm-12">
            <div className="field-container">
              <label className="field-placeholder font-medium">
                Receiving Path{" "}
              </label>
              <input
                type="text"
                className="field-input"
                value={FaxData.path}
                name="receivingPath"
                placeholder="D:\Inbound Faxes\"
                readOnly
              />
            </div>
          </div>
          <div
            className={`${KiosData.kiosBtn ? "d-inline-block" : "d-none"
              } col-md-12 col-sm-12 text-center`}
          >
            {(sessionStorage.getItem("type") !== "CS" ||
              sessionStorage.getItem("type") !== "CSM") && (
                <input
                  type="button"
                  className="btnLinkGreen btnUpdate"
                  value="Save"
                  onClick={() => SaveFax()}
                />
              )}
          </div>
          <div className="row table-panel-header mt-4 bg-white">
            <div className="col-md-12">
              <h6>Kiosk Setup</h6>
            </div>
          </div>
          <div className="col-md-12 col-sm-12">
            {kiosToggle.title.length > 0 && ConfigrationSetup(kiosToggle)}
          </div>
          <div className="col-md-12 col-sm-12">
            <div className="field-container">
              <label className="field-placeholder font-medium">
                Email<span className="redboxRequired" />{" "}
              </label>
              <input
                type="text"
                className="field-input"
                name="email"
                value={KiosData.email}
                onChange={(e) => AlterSettingData(e, "kiosk")}
                onFocus={(e) => ValidateBoxLength(e, "kiosk")}
              />
            </div>
            <label className="requiredtext">{Error.email}</label>
          </div>
          <div className="col-md-12 col-sm-12">
            <div className="field-container">
              <label className="field-placeholder font-medium">
                Password<span className="redboxRequired" />{" "}
              </label>
              <input
                type="password"
                className="field-input"
                value={KiosData.password}
                onChange={(e) => AlterSettingData(e, "kiosk")}
                onFocus={(e) => ValidateBoxLength(e, "kiosk")}
                name="password"
              />
            </div>
            <label className="requiredtext">{Error.password}</label>
          </div>
          <div className="col-md-12 col-sm-12">
            <div className="field-container">
              <label className="field-placeholder font-medium">
                Template SeqNum<span className="redboxRequired" />{" "}
              </label>
              <input
                type="text"
                className="field-input"
                name="template"
                value={KiosData.template}
                onChange={(e) => AlterSettingData(e, "kiosk")}
                onFocus={(e) => ValidateBoxLength(e, "kiosk")}
              />
            </div>
            <label className="requiredtext">{Error.template}</label>
          </div>
          <div className="col-md-12 col-sm-12">
            <div className="field-container">
              <label className="field-placeholder font-medium">
                Reason SeqNum
              </label>
              <input
                type="text"
                className="field-input"
                name="reason"
                onChange={(e) => AlterSettingData(e, "kiosk")}
                value={KiosData.reason}
                disabled={KiosData.ReasonDisable}
              />
            </div>
          </div>
          <div className="row justify-content-center">
            {sessionStorage.getItem("type") !== "CS" &&
              sessionStorage.getItem("type") !== "CSM" && (
                <div className="text-center">
                  <input
                    type="button"
                    className="btnLinkGreen btnUpdate"
                    value="Save"
                    onClick={() => KioskSetup()}
                  />
                  {KiosData.reason === "" && (
                    <input
                      type="button"
                      className={`${KiosData.kiosBtn ? "btnLinkGreen btnUpdate" : "d-none"
                        } text-center`}
                      value="Create Reason"
                      onClick={() => CreateReason("Kiosk")}
                    />
                  )}
                </div>
              )}
          </div>
          <div className="row table-panel-header mt-4 bg-white">
            <div className="col-md-12">
              <h6>TeleVisit Setup</h6>
            </div>
          </div>

          <div className="col-md-12 col-sm-12">
            {ConfigrationSetup(VisitToggle)}
          </div>

          <div className="col-md-12 col-sm-12">
            <div className="field-container">
              <label className="field-placeholder font-medium">
                Opentoken Secretkey<span className="redboxRequired" />{" "}
              </label>
              <input
                type="text"
                className="field-input"
                name="secretKey"
                onChange={(e) => AlterSettingData(e, "teleVisit")}
                value={VisitData.secretKey}
              />
            </div>
            <label className="requiredtext">{Error.secretKey}</label>
          </div>
          <div className="col-md-12 col-sm-12">
            <div className="field-container">
              <label className="field-placeholder font-medium">
                Opentoken Apikey<span className="redboxRequired" />{" "}
              </label>
              <input
                type="text"
                className="field-input"
                name="apiKey"
                onChange={(e) => AlterSettingData(e, "teleVisit")}
                value={VisitData.apiKey}
              />
            </div>
            <label className="requiredtext">{Error.apiKey}</label>
          </div>
          <div className="col-md-12 col-sm-12 text-center mt-4">
            {sessionStorage.getItem("type") !== "CS" &&
              sessionStorage.getItem("type") !== "CSM" && (
                <input
                  type="button"
                  className="btnLinkGreen btnUpdate"
                  value="Save"
                  onClick={() => TeleVisitSetup()}
                />
              )}
          </div>
          <div className="col-md-12 col-sm-12">
            <div className="field-container">
              <label className="field-placeholder font-medium">
                Reason SeqNum
              </label>
              <input
                type="text"
                className="field-input"
                name="portalUrl"
                value={VisitData.reason}
                onChange={(e) => AlterSettingData(e, "teleVisit")}
              />
            </div>
          </div>
          {VisitData.reason === "" && (
            <div className="row ">
              {sessionStorage.getItem("type") !== "CS" &&
                sessionStorage.getItem("type") !== "CSM" && (
                  <div className="col-md-12 col-sm-12 text-center">
                    <input
                      type="button"
                      className={`${VisitData.visitBtn ? "btnLinkGreen btnUpdate" : "d-none"
                        } text-center`}
                      value="Create Reason"
                      onClick={() => CreateReason("teleVisit")}
                    />
                  </div>
                )}
            </div>
          )}
        </div>

        <div className="col-md-6 col-sm-12">
            <PayrixSetting />

          <div className="row table-panel-header mt-4 bg-white">
            <div className="col-md-12">
              <h6>Patient Portal Setup</h6>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 col-sm-12">
              <div className="field-container">
                <label className="field-placeholder font-medium">
                  Patient Portal URL<span className="redboxRequired" />{" "}
                </label>
                <input
                  type="text"
                  className="field-input"
                  name="portalUrl"
                  value={PortalData.portalUrl}
                  onChange={(e) => AlterSettingData(e, "portal")}
                  onFocus={(e) => ValidateBoxLength(e)}
                />
              </div>
              <label className="requiredtext">{Error.portalUrl}</label>
            </div>
            <div className="col-md-12 col-sm-12">
              <div className="field-container">
                <label className="field-placeholder font-medium">
                  Company Name<span className="redboxRequired" />{" "}
                </label>
                <input
                  type="text"
                  className="field-input"
                  name="companyName"
                  value={PortalData.companyName}
                  onChange={(e) => AlterSettingData(e, "portal")}
                  onFocus={(e) => ValidateBoxLength(e)}
                />
              </div>

              <label className="requiredtext">{Error.companyName}</label>
            </div>
            <div className="col-md-12 col-sm-12">
              <div className="field-container">
                <label className="field-placeholder font-medium">
                  Practice Name<span className="redboxRequired" />{" "}
                </label>
                <input
                  type="text"
                  className="field-input"
                  name="practiceName"
                  value={PortalData.practiceName}
                  onChange={(e) => AlterSettingData(e, "portal")}
                  onFocus={(e) => ValidateBoxLength(e)}
                />
              </div>
              <label className="requiredtext">{Error.practiceName}</label>
            </div>
            <div className="col-md-12 col-sm-12">
              <div className="field-container">
                <label className="field-placeholder font-medium">
                  Default Medication User
                  <span className="redboxRequired" />{" "}
                </label>
                <input
                  type="text"
                  className="field-input"
                  name="medicationUser"
                  value={PortalData.medicationUser}
                  onChange={(e) => AlterSettingData(e, "portal")}
                  onFocus={(e) => ValidateBoxLength(e)}
                />
              </div>
              <label className="requiredtext">{Error.medicationUser}</label>
            </div>
            <div className="col-md-12 col-sm-12">
              <div className="field-container">
                <label className="field-placeholder font-medium">
                  Default Lab User<span className="redboxRequired" />{" "}
                </label>
                <input
                  type="text"
                  className="field-input"
                  name="labUser"
                  value={PortalData.labUser}
                  onChange={(e) => AlterSettingData(e, "portal")}
                  onFocus={(e) => ValidateBoxLength(e)}
                />
              </div>
              <label className="requiredtext">{Error.labUser}</label>
            </div>
            <div className="col-md-12 col-sm-12">
              <div className="field-container">
                <label className="field-placeholder font-medium">
                  Default Patient Registration User
                  <span className="redboxRequired" />{" "}
                </label>
                <input
                  type="text"
                  className="field-input"
                  name="registerUser"
                  value={PortalData.registerUser}
                  onChange={(e) => AlterSettingData(e, "portal")}
                  onFocus={(e) => ValidateBoxLength(e, "portal")}
                />
              </div>
              <label className="requiredtext">{Error.registerUser}</label>
            </div>

            {PortalData.portalConfig && (
              <>
                <div className="col-md-12 col-sm-12">
                  <div className="field-container">
                    <label className="field-placeholder font-medium">
                      Default Location:
                    </label>
                    <select
                      className="field-input"
                      value={PortalData.location}
                      name="location"
                      onChange={(e) => AlterSettingData(e, "portal")}
                    >
                      {LocationData.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="col-md-12 col-sm-12">
                  <div className="field-container">
                    <label className="field-placeholder font-medium">
                      Default Provider:
                    </label>
                    <select
                      className="field-input"
                      value={PortalData.provider}
                      name="provider"
                      onChange={(e) => AlterSettingData(e, "portal")}
                    >
                      {ProviderData.map((option) => (
                        <option value={option.value}>{option.label}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </>
            )}

            {/* {PortalData.portalBtn === true && ( */}
            <div className="col-md-12 col-sm-12">
              {PortalToggle.title.length > 0 && ConfigrationSetup(PortalToggle)}
            </div>
            {/* )} */}

            <div className="col-md-12 col-sm-12 text-center mt-4">
              {sessionStorage.getItem("type") !== "CS" &&
                sessionStorage.getItem("type") !== "CSM" && (
                  <input
                    type="button"
                    className="btnLinkGreen btnUpdate"
                    value={PortalData.portalId !== "" ? "Update" : "Save"}
                    onClick={() => PortalSetup()}
                  />
                )}
            </div>

            <div className="row table-panel-header mt-4 bg-white">
              <div className="col-md-12">
                <h6>
                  Ambir Scanning <span className="text-lg text-red-500">*</span>
                </h6>
              </div>
            </div>

            <div className="col-md-12 col-sm-12">
              {ConfigrationSetup(AmbirToggle)}
            </div>
          </div>
        </div>
      </div>

      <ConfirmDialog
        visible={confirm}
        onHide={() => setConfirm(false)}
        message={Boxes.message}
        header="Please Confirm"
        accept={accept}
        reject={reject}
      />
    </>
  );
};
export default Setting;








